export const emojis = [
  '😀',
  '😃',
  '😄',
  '😁',
  '😆',
  '😅',
  '😂',
  '🤣',
  '🥲',
  '🤔',
  '😊',
  '😇',
  '🙂',
  '🙃',
  '😉',
  '😌',
  '😍',
  '🥰',
  '😘',
  '😗',
  '😙',
  '😚',
  '😋',
  '😛',
  '😝',
  '😜',
  '🤪',
  '🤨',
  '🧐',
  '🤓',
  '😎',
  '🥸',
  '🤩',
  '🥳',
  '😏',
  '😒',
  '😞',
  '😔',
  '😟',
  '😕',
  '🙁',
  '👻',
  '😣',
  '😖',
  '😫',
  '😩',
  '🥺',
  '😢',
  '😭',
  '😤',
  '😠',
  '😡',
  '🤬',
  '🤯',
  '😳',
  '🥵',
  '😵‍💫',
  '🥴',
  '🐷',
  '💀',
  '👽',
  '🤷‍♂️',
  '🎉',
  '👌🏽',
  '👉🏽',
  '👇🏽',
  '👆🏽',
  '👈🏽',
  '🤏🏽',
  '🙌',
  '☕',
  '❎',
  '✅',
  '❌',
  '✈️',
  '💻',
  '💣',
  '🎯',
  '🥇',
  '🥈',
  '🥉',
  '🍕',
  '🍟',
  '🍥',
  '🎶',
  '✉️',
  '⏰',
  '🕶️',
];
